var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralUnitype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_031---University",
    "data-name": "031---University",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M51.724,28.414V46.793H39V27Z",
    transform: "translate(-11.431 -7.914)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M13.724,27V46.793H1V28.414Z",
    transform: "translate(-0.293 -7.914)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "M17,27H33.966V46.793H17Z",
    transform: "translate(-4.983 -7.914)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M25.707,40h4.241a.707.707,0,0,1,.707.707V49.19H25V40.707A.707.707,0,0,1,25.707,40Z",
    transform: "translate(-7.328 -11.724)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48093",
    "data-name": "Group 48093",
    transform: "translate(3.534 22.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M25.707,34.828A.707.707,0,0,1,25,34.121V32.707a.707.707,0,0,1,1.414,0v1.414A.707.707,0,0,1,25.707,34.828Z",
    transform: "translate(-10.862 -32)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M11.707,35.828A.707.707,0,0,1,11,35.121V33.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,11.707,35.828Z",
    transform: "translate(-6.759 -32.293)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M5.707,35.828A.707.707,0,0,1,5,35.121V33.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,5.707,35.828Z",
    transform: "translate(-5 -32.293)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M11.707,41.828A.707.707,0,0,1,11,41.121V39.707a.707.707,0,0,1,1.414,0v1.414A.707.707,0,0,1,11.707,41.828Z",
    transform: "translate(-6.759 -34.052)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M5.707,41.828A.707.707,0,0,1,5,41.121V39.707a.707.707,0,0,1,1.414,0v1.414A.707.707,0,0,1,5.707,41.828Z",
    transform: "translate(-5 -34.052)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M11.707,47.828A.707.707,0,0,1,11,47.121V45.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,11.707,47.828Z",
    transform: "translate(-6.759 -35.81)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M5.707,47.828A.707.707,0,0,1,5,47.121V45.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,5.707,47.828Z",
    transform: "translate(-5 -35.81)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M51.707,35.828A.707.707,0,0,1,51,35.121V33.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,51.707,35.828Z",
    transform: "translate(-18.483 -32.293)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M45.707,35.828A.707.707,0,0,1,45,35.121V33.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,45.707,35.828Z",
    transform: "translate(-16.724 -32.293)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M51.707,41.828A.707.707,0,0,1,51,41.121V39.707a.707.707,0,0,1,1.414,0v1.414A.707.707,0,0,1,51.707,41.828Z",
    transform: "translate(-18.483 -34.052)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M45.707,41.828A.707.707,0,0,1,45,41.121V39.707a.707.707,0,0,1,1.414,0v1.414A.707.707,0,0,1,45.707,41.828Z",
    transform: "translate(-16.724 -34.052)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M51.707,47.828A.707.707,0,0,1,51,47.121V45.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,51.707,47.828Z",
    transform: "translate(-18.483 -35.81)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M45.707,47.828A.707.707,0,0,1,45,47.121V45.707a.707.707,0,1,1,1.414,0v1.414A.707.707,0,0,1,45.707,47.828Z",
    transform: "translate(-16.724 -35.81)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M31.707,34.828A.707.707,0,0,1,31,34.121V32.707a.707.707,0,0,1,1.414,0v1.414A.707.707,0,0,1,31.707,34.828Z",
    transform: "translate(-12.621 -32)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    d: "M40.293,53H.707A.707.707,0,0,0,0,53.707v1.414a.707.707,0,0,0,.707.707h9.9a.707.707,0,0,0,.707.707H29.69a.707.707,0,0,0,.707-.707h9.9A.707.707,0,0,0,41,55.121V53.707A.707.707,0,0,0,40.293,53Z",
    transform: "translate(0 -15.534)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-19",
    "data-name": "Shape",
    d: "M34.793,53v2.828a.707.707,0,0,1-.707.707H15.707A.707.707,0,0,1,15,55.828V53Z",
    transform: "translate(-4.397 -15.534)",
    fill: "#c5e0dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-20",
    "data-name": "Shape",
    d: "M32.724,4.62v8.751H20V4.62l6.185,2.454a.515.515,0,0,0,.353,0Z",
    transform: "translate(-5.862 -1.354)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-21",
    "data-name": "Shape",
    d: "M38.854,21.44a1.414,1.414,0,0,0-1.265-.785H32.1V19.241l-3.824-3.824a1.418,1.418,0,0,0-1-.417H13.682a1.4,1.4,0,0,0-1.089.509l-3.11,3.732v1.414H4a1.414,1.414,0,0,0-1.265.785L1,24.9H40.586Z",
    transform: "translate(-0.293 -4.397)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-22",
    "data-name": "Shape",
    d: "M35.621,21v2.121a.707.707,0,0,1-.707.707H13.707A.707.707,0,0,1,13,23.121V21Z",
    transform: "translate(-3.81 -6.155)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path-2",
    "data-name": "Rectangle-path",
    d: "M15,25H34.793v2.828H15Z",
    transform: "translate(-4.397 -7.328)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-23",
    "data-name": "Shape",
    d: "M34.788,3.181a.686.686,0,0,1-.523.686l-.891.24-2.121.573L25.068,6.341a.747.747,0,0,1-.353,0L18.53,4.68l-3.011-.813a.707.707,0,0,1,0-1.371l9.2-2.474a.747.747,0,0,1,.353,0l8.306,2.234.891.24A.686.686,0,0,1,34.788,3.181Z",
    transform: "translate(-4.392 0)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-24",
    "data-name": "Shape",
    d: "M42.944,9.484a.707.707,0,0,1-.587.318.664.664,0,0,1-.389-.12A2.154,2.154,0,0,1,41,7.879V5.426l.891-.24a.686.686,0,0,0,.523-.686V7.879a.754.754,0,0,0,.339.629.7.7,0,0,1,.191.976Z",
    transform: "translate(-12.017 -1.319)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralUnitype);
export default __webpack_public_path__ + "static/media/university-general-unitype.4d144a203b691d1a66f299769f5468e3.svg";
export { ForwardRef as ReactComponent };